import { FormExtractorService } from "../../../shared/services/form-extractor.service";
import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_525 implements Validator {

    public static id = 'CTRL_525';
    private message = 'error.ctr_525';


    public LOG: LogService = new LogService(CTRL_525);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_525.id + '_');

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                let numLot = rg.substr(rg.length - 1);
                const valeurBasseNameWithStepId = map.get(ctrl.value.rgCtrls.valeurBasse.replace('INDEX_525_1', numLot));
                const valeurHauteNameWithStepId = map.get(ctrl.value.rgCtrls.valeurHaute.replace('INDEX_525_1', numLot));
                const valeurBasseCtrl = form.controls[valeurBasseNameWithStepId];
                const valeurHauteCtrl = form.controls[valeurHauteNameWithStepId];

                if (valeurBasseCtrl.value !== null && valeurHauteCtrl.value === null) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}
